import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import QueryBuilder from "./QueryBuilder";
import {
    fetchAllBusinessObjects,
    getRuleEngineOperators,
    createGraphQLRequest
} from "../../actions/boCoreActions";
import history from "../../config/history";
import {useEffect, useState} from "react";
import toastr from 'toastr';
import {Type} from "../../InputUtils";
import Input from "../../components/common/Input/Input";
import _ from "lodash";
import LoadingModal from "../../components/bo-core/modals/LoadinModal";
import Utils from "../../Utils";
import {Prompt} from "react-router";
import * as gql from "gql-query-builder";

const eventTypeOptions: any[] = [
    {
        label: 'Create',
        value: 'CREATE'
    },
    {
        label: 'Update',
        value: 'UPDATE'
    },
    {
        label: 'Delete',
        value: 'DELETE'
    }
];

export default function RuleEngineRule(props: any) {
    const dispatch = useDispatch();
    const allTypes = useSelector((store: any) => store.boCore.allTypes);

    const [businessObjectsOptions, setBusinessObjectsOptions] = useState<any[]>([]);
    const [attributes, setAttributes] = useState<any[]>([]);
    const [currentRule, setCurrentRule] = useState<any>(null);
    const [operators, setOperators] = useState<string[]>([]);
    const [queryBuilderRef, setQueryBuilderRef] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [actionOptions, setActionOptions] = useState<any>([]);
    const [isLeaving, setIsLeaving] = useState<boolean>(false);
    const [form, setForm] = useState<any>({
        name: {
            value: '',
            valid: true,
            errorMsg: 'Rule name cannot be empty'
        },
        typeKey: {
            value: null,
            valid: true,
            errorMsg: 'Instance type cannot be empty',
        },
        eventType: {
            value: [],
            valid: true,
            errorMsg: 'Event type cannot be empty',
        },
        assignedActions: {
            value: [],
            valid: true
        }
    });

    useEffect(() => {
        document.addEventListener('keydown', keydownHandler);
        const id = props.match.params['id'];
        if (id && !isNaN(Number(id))) {
            setLoading(true);
            const activeActionsFields = {
                records: ["id,name"]
            }
            const getAllActiveActionsQuery = gql.query({
                operation: `SysRuleEngineActions(qry: "active==1")`,
                fields: [activeActionsFields]
            });
            createGraphQLRequest(getAllActiveActionsQuery, (data) => {
                setLoading(false);
                setActionOptions(data.SysRuleEngineActions.records.map(action => {
                    return {
                        label: action.name,
                        value: action.id
                    }
                }));
            }, (error) => {
                toastr.error(error.message);
                setLoading(false);
            });
            dispatch(fetchAllBusinessObjects());
            getRuleEngineOperators()
                .then(response => {
                    setOperators(response.data)
                });
            if (id !== "-1") {
                setLoading(true);
                const currentRuleFields = {
                    records: [
                        "id,name,typeKey,eventType,rule",
                        {
                            SysRuleEngineRulesBelongsToSysRuleEngineActions: [{
                                relations: [{
                                    record: ["id"]
                                }]
                            }]
                        }
                    ]
                }
                const getCurrentRuleQuery = gql.query({
                    operation: `SysRuleEngineRules(qry: "id==${id}")`,
                    fields: [currentRuleFields]
                });
                createGraphQLRequest(getCurrentRuleQuery, (data) => {
                    setLoading(false);
                    if (data.SysRuleEngineRules.records.length > 0) {
                        setCurrentRule(data.SysRuleEngineRules.records[0]);
                    } else {
                        toastr.error('Cannot find rule with such id.');
                        history.push(`${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineRules}`);
                    }
                }, (error) => {
                    toastr.error(error.message);
                    setLoading(false);
                });
            }
        } else {
            history.push(`${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineRules}`);
        }
        return () => {
            document.removeEventListener('keydown', keydownHandler);
        };
    }, []);

    useEffect(() => {
        if (allTypes && actionOptions.length > 0) {
            setBusinessObjectsOptions(allTypes.sort((a, b) => a.name.localeCompare(b.name))
                .map(item => {
                    return {
                        value: item.boKey,
                        label: item.name
                    }
                }));
            if (currentRule) {
                loadRuleToForm();
            }
        }
    }, [allTypes, actionOptions, currentRule]);

    const loadTypeKey = (value) => {
        let selectedTypeKey = null;
        const foundType = allTypes.find(type => {
            return type.boKey === value;
        })
        if (foundType) {
            selectedTypeKey = {value: foundType.boKey, label: foundType.name};
            setAttributes(foundType.attributes);
        }

        return selectedTypeKey;
    };

    const loadEventTypes = (values) => {
        return values.map(type => {
            return eventTypeOptions.find(option => {
                return option.value === type
            })
        });
    };

    const loadActionValues = (actionIds) => {
        const options = [];
        actionIds.forEach(actionId => {
            const foundOption = actionOptions.find(option => {
                return option.value === actionId
            });
            if (foundOption) {
                options.push(foundOption);
            }
        });
        return options;
    };

    const loadRuleToForm = () => {
        let formCopy = JSON.parse(JSON.stringify(form));
        if (currentRule) {
            const currentRuleCopy = JSON.parse(JSON.stringify(currentRule));
            const keys = Object.keys(currentRuleCopy);

            keys.forEach(key => {
                if (key === 'name' || key === 'typeKey' || key === 'eventType' || key === 'SysRuleEngineRulesBelongsToSysRuleEngineActions') {
                    switch (key) {
                        case "typeKey":
                            formCopy = {
                                ...formCopy,
                                [key]: {
                                    ...formCopy[key],
                                    value: currentRuleCopy[key] ? loadTypeKey(currentRuleCopy[key]) : []
                                }
                            };
                            break;
                        case 'eventType':
                            formCopy = {
                                ...formCopy,
                                [key]: {
                                    ...formCopy[key],
                                    value: currentRuleCopy[key] ? loadEventTypes(currentRuleCopy[key]) : []
                                }
                            };
                            break;
                        case 'SysRuleEngineRulesBelongsToSysRuleEngineActions':
                            formCopy = {
                                ...formCopy,
                                assignedActions: {
                                    ...formCopy['assignedActions'],
                                    value: currentRuleCopy[key] ? loadActionValues(currentRuleCopy[key].relations.map(rel => {
                                        return rel.record?.id;
                                    })) : []
                                }
                            };
                            break;
                        default:
                            formCopy = {
                                ...formCopy,
                                [key]: {
                                    ...formCopy[key],
                                    value: currentRuleCopy[key] ? currentRuleCopy[key] : ''
                                }
                            };
                    }
                }
            });
        }
        setForm(formCopy);
    }

    const keydownHandler = (e) => {
        if (e.ctrlKey && e.altKey && e.keyCode === 83) {
            document.getElementById('save-rule-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 8) {
            document.getElementById('back-to-list-btn').click();
        }
    };

    const onChange = (event, id, inputType) => {
        let eventValue;
        if (inputType === 'select') {
            eventValue = event ? event : [];
            if (id === 'typeKey') {
                const foundType = allTypes.find(type => {
                    return type.boKey === event.value;
                })
                if (foundType) {
                    setAttributes(foundType.attributes);
                }
            }
        } else {
            eventValue = event.target.value;
        }

        setForm({
            ...form,
            [id]: {
                ...form[id],
                value: eventValue,
                valid: true
            }
        });
    };

    const checkFormValidity = (): boolean => {
        const keys = Object.keys(form);
        const formCopy = JSON.parse(JSON.stringify(form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            switch (key) {
                case 'name':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'typeKey':
                    if (!formCopy[key].value) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'eventType':
                    if (formCopy[key].value.length === 0) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
            }
        })

        setForm(formCopy);

        return formIsValid;
    };

    const constructEditDTO = (rules) => {
        const dto = {};
        Object.keys(currentRule).forEach(key => {
            switch (key) {
                case 'name': {
                    if (currentRule[key] !== form[key].value) {
                        dto[key] = form.name.value;
                    }
                    break;
                }
                case 'typeKey': {
                    if (currentRule[key] !== form[key].value.value) {
                        dto[key] = form[key].value.value;
                    }
                    break;
                }
                case 'eventType': {
                    const currentRuleCopy = [...currentRule[key]].sort();
                    const formArrayCopy = form[key].value.map(item => {
                        return item.value
                    }).sort();
                    if (!_.isEqual(currentRuleCopy, formArrayCopy)) {
                        dto[key] = {replace: formArrayCopy};
                    }
                    break;
                }
                case 'rule': {
                    if (!_.isEqual(JSON.parse(currentRule[key]), rules)) {
                        dto[key] = JSON.stringify(rules);
                    }
                    break;
                }
                case 'SysRuleEngineRulesBelongsToSysRuleEngineActions': {
                    const currentIds = currentRule[key].relations.map(rel => {
                        return rel.record?.id;
                    }).sort();
                    const newIds = form['assignedActions'].value.map(el => {
                        return el.value;
                    }).sort();

                    if (!_.isEqual(currentIds, newIds)) {
                        const actionsObj: any = {};
                        const addedIds = [];
                        const removedIds = [];

                        newIds.forEach(newId => {
                            if (typeof currentIds.find(currId => currId === newId) === 'undefined') {
                                addedIds.push(newId);
                            }
                        });
                        currentIds.forEach(currId => {
                            if (typeof newIds.find(newId => newId === currId) === 'undefined') {
                                removedIds.push(currId);
                            }
                        });

                        if (addedIds.length > 0) {
                            actionsObj['add'] = addedIds.map(id => {
                                return {
                                    recordId: id
                                }
                            })
                        }
                        if (removedIds.length > 0) {
                            actionsObj['remove'] = removedIds.map(id => {
                                return {
                                    recordId: id
                                }
                            })
                        }

                        if (Object.keys(actionsObj).length > 0) {
                            dto[key] = actionsObj;
                        }
                    }
                    break;
                }
            }
        });

        return dto;
    };

    const stringifyValues = (obj: any) => {
        let stringValues = '';
        Object.keys(obj).forEach((key, index) => {
            let val = '';
            if (typeof obj[key] === 'object') {
                val = JSON.stringify(obj[key]).replace(/"([^"]+)":/g, '$1:');
                stringValues += `${key}: ${val}`;
            } else {
                val = obj[key].replace(/[\""]/g, '\\"');
                stringValues += `${key}: "${val}"`;
            }

            if (index < Object.keys(obj).length - 1) {
                stringValues += ', '
            }
        })
        return stringValues;
    }

    const onSaveRule = () => {
        let rules = null;
        if (form.typeKey.value) {
            // @ts-ignore
            rules = $(queryBuilderRef).queryBuilder('getRules');
        }

        if (checkFormValidity() && rules) {
            if (props.match.params['id'] === "-1") {
                const createRuleParams = {
                    name: form.name.value,
                    typeKey: form.typeKey.value.value,
                    rule: JSON.stringify(rules),
                    eventType: form.eventType.value.map(type => {
                        return type.value
                    })
                };
                if (form.assignedActions.value.length > 0) {
                    const actionsIds = form.assignedActions.value.map(action => {
                        return {
                            recordId: action.value
                        };
                    });
                    createRuleParams['SysRuleEngineRulesBelongsToSysRuleEngineActions'] = {
                        add: actionsIds
                    };
                }

                setLoading(true);
                const insertRuleFields = [
                    "id,name,typeKey,eventType,rule",
                    {
                        SysRuleEngineRulesBelongsToSysRuleEngineActions: [{
                            relations: [{
                                record: ["id"]
                            }]
                        }]
                    }
                ];
                const insertRuleMutation = gql.mutation({
                    operation: `InsertSysRuleEngineRulesRecord(record: {${stringifyValues(createRuleParams)}})`,
                    fields: insertRuleFields
                });
                createGraphQLRequest(insertRuleMutation, (data) => {
                    setLoading(false);
                    toastr.success("Rule successfully created");
                    setCurrentRule(data.InsertSysRuleEngineRulesRecord);
                    setIsLeaving(true);
                    history.replace(`${process.env.ENV_PREFIX}/rules/${data.InsertSysRuleEngineRulesRecord.id}`);
                }, (error) => {
                    setLoading(false);
                    toastr.error(error.message);
                });
            } else {
                const dto = constructEditDTO(rules);
                if (Object.keys(dto).length > 0) {
                    setLoading(true);
                    const updateRuleFields = {
                        records: [
                            "id,name,typeKey,eventType,rule",
                            {
                                SysRuleEngineRulesBelongsToSysRuleEngineActions: [{
                                    relations: [{
                                        record: ["id"]
                                    }]
                                }]
                            }
                        ]
                    }
                    const updateRuleMutation = gql.mutation({
                        operation: `UpdateSysRuleEngineRulesRecords(qry: "id==${props.match.params['id']}", maxRecordsToUpdate: 1, ${stringifyValues(dto)})`,
                        fields: [updateRuleFields]
                    });
                    createGraphQLRequest(updateRuleMutation, (data) => {
                        toastr.success("Rule successfully updated");
                        setCurrentRule(data.UpdateSysRuleEngineRulesRecords.records[0]);
                        setLoading(false);
                    }, (error) => {
                        setLoading(false);
                        toastr.error(error.message);
                    });
                } else {
                    toastr.warning("There are no changes.");
                }
            }
        }
    };

    const initializeRef = (el) => {
        setQueryBuilderRef(el);
    };

    const onBackToList = () => {
        if (localStorage.getItem('cameFromGlobalSearch')) {
            localStorage.removeItem('cameFromGlobalSearch');
            history.push(`${process.env.ENV_PREFIX}/globalsearch`);
        } else if (localStorage.getItem('cameFromAuditLog')) {
            localStorage.removeItem('cameFromAuditLog');
            history.push(`${process.env.ENV_PREFIX}/audit-log`);
        } else {
            history.push(`${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineRules}`);
        }
    };

    const confirmModal = (nextLocation: any) => {
        if (areThereChanges()) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: 'There are unsaved changes. Are you sure you want to continue?',
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            setIsLeaving(true);
                            history.push(nextLocation)
                        }
                    },
                    cancel: () => {

                    }
                }
            });
            return false
        }
        return true
    }

    const areThereChanges = () => {
        if (isLeaving) {
            return false
        }
        if (props.match.params['id'] !== "-1") {
            let rules = null;
            if (form.typeKey.value) {
                // @ts-ignore
                rules = $(queryBuilderRef).queryBuilder('getRules');
            }
            if (checkFormValidity() && rules) {
                return Object.keys(constructEditDTO(rules)).length > 0;
            }
            return true;
        }
        return true;
    };

    return (
        <div style={{height: "100%", width: "100%"}} className="bo-core">
            <div style={{height: 50, backgroundColor: "#2D3436", display: "flex"}}
                 className="bo-core-header top-header">
                <div style={{paddingLeft: 2, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <span id="rule-title" className="header-title">
                        {props.match.params['id'] === "-1" ? "Create Rule" : "Update Rule"}
                    </span>
                    <div className="control-buttons">
                        <button id={'save-rule-btn'} onClick={onSaveRule} style={{marginRight: 5}}
                                className={"btn btn-primary"} title={'Save Rule (CTRL + ALT + S)'}>
                            <i className="fas fa-save"/> <strong className={'shortcut-btn-letters'}>S</strong>ave
                        </button>
                        <button onClick={onBackToList} id={'back-to-list-btn'}
                                className={"btn btn-new-design"} title={'Back To List (CTRL + ALT + BACKSPACE)'}>
                            <i className="fas fa-backward"> Back To List</i>
                        </button>
                    </div>
                </div>
            </div>
            <div style={{
                width: "100%",
                height: '100%',
                backgroundColor: '#2D3436',
                padding: 10
            }}>
                <div style={{width: '100%', display: 'flex'}}>
                    <div style={{width: '100%', marginRight: '1%'}}>
                        <Input id={'ruleName'}
                               value={form.name.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'name', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.name.valid}
                               errorMsg={form.name.errorMsg}
                               label={'Rule Name*'}
                               elementConfig={{
                                   placeholder: 'Rule Name',
                                   tabIndex: 1
                               }}
                        />
                    </div>
                    <div style={{width: '100%'}}>
                        <Input id={'instanceType'}
                               value={form.typeKey.value}
                               required={true}
                               elementType={Type.SELECT}
                               changed={(event) => onChange(event, 'typeKey', 'select')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               errorMsg={form.typeKey.errorMsg}
                               valid={form.typeKey.valid}
                               selectInitialPosition={false}
                               label={'Instance Type*'}
                               elementConfig={{
                                   placeholder: 'Select Instance Type',
                                   isMulti: false,
                                   closeMenuOnSelect: true,
                                   tabIndex: 2,
                                   options: businessObjectsOptions
                               }}
                        />
                    </div>
                </div>
                <div style={{width: '100%', display: 'flex'}}>
                    <div style={{width: '100%', marginRight: '1%'}}>
                        <Input id={'eventType'}
                               value={form.eventType.value}
                               required={true}
                               elementType={Type.SELECT}
                               changed={(event) => onChange(event, 'eventType', 'select')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               errorMsg={form.eventType.errorMsg}
                               valid={form.eventType.valid}
                               selectInitialPosition={false}
                               label={'Event Type*'}
                               elementConfig={{
                                   placeholder: 'Select Event Type',
                                   isMulti: true,
                                   closeMenuOnSelect: false,
                                   tabIndex: 3,
                                   options: eventTypeOptions
                               }}
                        />
                    </div>
                    <div style={{width: '100%'}}>
                        <Input id={'assignedActions'}
                               value={form.assignedActions.value}
                               elementType={Type.SELECT}
                               changed={(event) => onChange(event, 'assignedActions', 'select')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.assignedActions.valid}
                               selectInitialPosition={false}
                               label={'Actions'}
                               elementConfig={{
                                   placeholder: 'Select Actions',
                                   isMulti: true,
                                   closeMenuOnSelect: false,
                                   tabIndex: 4,
                                   options: actionOptions
                               }}
                        />
                    </div>
                </div>
                {form.typeKey.value ? <label className={'inputLabels'}>Rules</label> : null}
                <QueryBuilder
                    attributes={attributes}
                    operators={operators}
                    initializeRef={initializeRef}
                    currentRules={currentRule && currentRule.typeKey === form.typeKey.value?.value ? currentRule.rule : null}
                />
            </div>
            <LoadingModal open={loading}/>
            <Prompt message={confirmModal}/>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/views/bo-core/RuleEngineRule.tsx